import { render, staticRenderFns } from "./UiPopOvers.vue?vue&type=template&id=fea2bc38&"
import script from "./UiPopOvers.vue?vue&type=script&lang=js&"
export * from "./UiPopOvers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports